<template>
    <div    v-if="modalExists"
            :class="zIndex"
            class="fixed z-10 inset-0 overflow-y-auto"
            @click="close">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
            <!--
              Modal panel, show/hide based on modal state.

              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
            <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <div    v-show="isOpen"
                        class="inline-block border border-gray-200 align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden
                            shadow-xl transition-all sm:my-8 sm:align-middle sm:w-full sm:p-6"
                        :class="maxWidth"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="modal-headline"
                        @click.stop="">
                    <div>
                        <slot name="icon">
                            <div    v-if="showIcon">
                                <div v-if="!isErrorModal" class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                                    <!-- Heroicon name: check -->
                                    <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <div v-else class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                                    <!-- Heroicon name: check -->
                                    <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </div>
                            </div>
                        </slot>
                        <div class="mt-2 text-center sm:mt-5">
                            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                                <slot name="title-content">
                                    Notification Title
                                </slot>
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    <slot>Notification Description</slot>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6">
                        <div v-if="giveOption" class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
                                <button type="button"
                                        @click="clickProceed"
                                        class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:ring-blue-200 sm:text-sm sm:leading-5">
                                    <slot     name="button-primary-content">
                                        Sounds Good
                                    </slot>
                                </button>
                            </span>
                            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
                                <button type="button"
                                        @click="clickCancel"
                                        class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue-200 sm:text-sm sm:leading-5">
                                    <slot       name="button-secondary-content">
                                        Cancel
                                    </slot>
                                </button>
                            </span>
                        </div>

                        <span v-else class="flex w-full rounded-md shadow-sm">
                            <button type="button"
                                    class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                                            bg-blue-600 text-base leading-6 font-medium text-white shadow-sm
                                            hover:bg-blue-500 focus:outline-none focus:border-blue-700
                                            focus:ring-blue-200 sm:text-sm sm:leading-5"
                                    @click="close">
                                <slot   name="button-primary-content">
                                    Okay
                                </slot>
                            </button>
                        </span>
                    </div>
                </div>
            </transition>

        </div>
    </div>

</template>

<script>

const CLOSE_DELAY = 200

export default {
    name: "NotificationModal",
    mixins: [],
    components: {},
    emits: ['update:isOpen', 'close', 'action', 'primary-action', 'secondary-action'],
    props: {
        isOpen: {
            type: Boolean,
            default: true,
        },
        isErrorModal: {
           type: Boolean,
           default: false,
        },
        giveOption: {
            type: Boolean,
            default: false
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        maxWidth: {
          type: String,
          default: 'sm:max-w-sm',
        },
        zIndex: {
            type: String,
            default: 'z-50',
        }
    },
    data() {
        return {
            modalExists: this.isOpen,
        }
    },
    mounted() {

    },
    methods: {
        close() {
            this.$emit('update:isOpen', false);
            // Adding the close event on modal close.
            this.$emit('close');
        },
        clickProceed(){
            this.$emit('action', true);
            this.$emit('primary-action')
            this.close();
        },
        clickCancel(){
            this.$emit('action', false);
            this.$emit('secondary-action')
            this.close();
        },
    },
    watch: {
        isOpen() {
            setTimeout(() => {
                this.modalExists = this.isOpen
            }, CLOSE_DELAY)
        },
    },
    computed: {

    },
}

</script>

<style scoped>

</style>